import React from "react";
import {observer} from "mobx-react-lite";


import "./PercentInputField.css"


export interface PercentInputFieldProps {
    value: number | '';
    onChange: (value: number | '') => void;
}


export const PercentInputField = observer((
    {
        value,
        onChange
    }: PercentInputFieldProps
) => {

    return (
        <div className={"PercentField"}>
            <input
                className="PercentInputField body-large"
                value={value}
                placeholder={'100'}
                onChange={(event) => {
                    const newValue = event.target.value ? parseInt(event.target.value) : '';
                    if (newValue === '' || (newValue >= 0 && newValue <= 100)) {
                        onChange(newValue);
                    }
                }}
            />
            %
        </div>
    )
})
